import React from "react";
import Helmet from "react-helmet";
import Hero from "../components/hero";
import TitleBar from "../components/title-bar";
import IconsSection from "../components/tarjetas/selector-de-categorias";
import GridDeTarjetas from "../components/tarjetas/grid-de-tarjetas";
import InterestRates from "../components/interest";
import Layout from "../components/layouts/tarjetas";
import { graphql } from "gatsby";
import StickyCta from "../components/botones/sticky-cta";
import Disclaimer from "../components/disclaimer";

class Home extends React.Component {
  render() {
    const { coleccion, multicanalidad, pais } = this.props.data;
    const showCollections = coleccion !== undefined && coleccion !== null;
    const categorias = this.props.data.allContentfulCategorias.edges.sort(
      (a, b) => a.node.orden - b.node.orden
    );
    const tasasDeInteres = this.props.data.tasasDeInteres.edges
      .map(i => i.node)
      .sort((a, b) => a.orden - b.orden);
    const { frontmatter } = this.props.data.page;
    const tarjetas = this.props.data.tarjetas.edges;
    const footer = this.props.data.footer
      ? this.props.data.footer.edges.map(f => f.node)
      : null;
    const {
      title,
      description,
      hero,
      utm,
      formUrl,
      heroImage,
      heroSubtitular,
      cta,
      crazyegg
    } = frontmatter;

    const isCostaRica = pais.title === "Costa Rica";

    return (
      <Layout
        {...{ pais }}
        footer={footer}
        multicanalidad={pais.title === "Costa Rica" && multicanalidad != null}
      >
        <Helmet
          title={title}
          meta={[{ name: "description", content: description }]}
        >
          {crazyegg === false ? null : (
            <script
              type="text/javascript"
              src="//script.crazyegg.com/pages/scripts/0083/4677.js"
              async="async"
            />
          )}
        </Helmet>
        {hero && (
          <Hero
            hero={hero}
            utm={utm || null}
            formUrl={formUrl || null}
            location={this.props.location}
            title={title}
            cta={cta}
            heroImage={heroImage}
            heroSubtitular={heroSubtitular}
            multicanalidad={isCostaRica ? multicanalidad : null}
            {...{ pais }}
          />
        )}

<IconsSection
          items={categorias}
          title="Categorías"
          subtitle={
            ["Costa Rica", "Nicaragua"].includes(pais.title)
              ? "Conocé las categorías y escogé tu tarjeta"
              : "Conoce las categorías y escoge tu tarjeta"
          }
          tarjetas={tarjetas}
          whatsapp={frontmatter.whatsapp}
          formUrl={formUrl || null}
          multicanalidad={isCostaRica ? multicanalidad : null}
          {...{ pais }}
        />
        
        {showCollections && (
          <TitleBar
            title={coleccion.displayTitle}
            subtitle={coleccion.description}
          />
        )}
        {showCollections && (
          <GridDeTarjetas
            tarjetas={coleccion.productos}
            whatsapp={frontmatter.whatsapp}
            formUrl={formUrl || null}
            multicanalidad={isCostaRica ? multicanalidad : null}
            {...{ pais }}
          />
        )}
 
        {pais.title === "Costa Rica" && (
          <TitleBar
            title="Tasas de interés"
            subtitle="La tasa preferencial aplica siempre y cuando el cliente esté al día. En caso de atraso se suspende por 6 meses."
          />
        )}
        {isCostaRica && <InterestRates rates={tasasDeInteres} />}
        {isCostaRica && <StickyCta multicanalidad={multicanalidad} />}
        <Disclaimer />
      </Layout>
    );
  }
}

export const query = graphql`
  query($collection: String, $pais: String!, $path: String!) {
    page: markdownRemark(frontmatter: { path: { eq: $path } }) {
      frontmatter {
        title
        description
        hero
        utm
        formUrl
        cta
        heroImage
        heroSubtitular
        whatsapp
        multicanalidad
        crazyegg
      }
    }

    multicanalidad: contentfulMulticanalidadLinks(
      identificador: { eq: "multicanalidad-tarjetas-cr" }
    ) {
      formLlamada
      telefono
      whatsapp
      form
    }

    allContentfulCategorias(filter: { pais: { glob: $pais } }) {
      edges {
        node {
          id
          titulo
          slug
          orden
          icono {
            file {
              url
              fileName
              contentType
            }
          }
        }
      }
    }

    tarjetas: allContentfulProducto(
      filter: { pais: { title: { eq: $pais } } }
    ) {
      edges {
        node {
          id
          titulo
          productPage
          formOpa
          categorias {
            titulo
            id
          }
          reglamento
          beneficiosGenerales {
            id
            titulo
          }
          variacion {
            titulo
            costo
            tipoDeCosto
            monedaDeCosto
            arte {
              sizes {
                base64
                aspectRatio
                src
                srcSet
                sizes
              }
              id
              title
              file {
                url
                fileName
                contentType
              }
            }
            color {
              titulo
              salarioMinimo
            }
          }
        }
      }
    }

    coleccion: contentfulColecciones(titulo: { eq: $collection }) {
      displayTitle
      description
      productos {
        id
        titulo
        productPage
        formOpa
        reglamento
        categorias {
          titulo
          id
        }
        beneficiosGenerales {
          id
          titulo
        }
        variacion {
          titulo
          costo
          tipoDeCosto
          monedaDeCosto
          arte {
            sizes {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
            id
            title
            file {
              url
              fileName
              contentType
            }
          }
          color {
            titulo
            salarioMinimo
          }
        }
      }
    }

    tasasDeInteres: allContentfulTasasDeInteres {
      edges {
        node {
          id
          titulo
          preferencialColones
          preferencialDolares
          normalColones
          normalDolares
          orden
        }
      }
    }

    pais: contentfulPais(title: { eq: $pais }) {
      title
      contryAbr
      countrySlug
    }

    footer: allContentfulFooter(filter: { pais: { eq: $pais } }) {
      edges {
        node {
          id
          type
          texto {
            texto
          }
        }
      }
    }
  }
`;

export default Home;
